export default __webpack_public_path__ + "static/media/green_tick.85a3c9ae.svg";